var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraUploadedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D5D7DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H19L21 14H27L29 16H32C32.5304 16 33.0391 16.2107 33.4142 16.5858C33.7893 16.9609 34 17.4696 34 18V30C34 30.5304 33.7893 31.0391 33.4142 31.4142C33.0391 31.7893 32.5304 32 32 32H16C15.4696 32 14.9609 31.7893 14.5858 31.4142C14.2107 31.0391 14 30.5304 14 30V18C14 17.4696 14.2107 16.9609 14.5858 16.5858C14.9609 16.2107 15.4696 16 16 16ZM24 19C22.6739 19 21.4021 19.5268 20.4645 20.4645C19.5268 21.4021 19 22.6739 19 24C19 25.3261 19.5268 26.5979 20.4645 27.5355C21.4021 28.4732 22.6739 29 24 29C25.3261 29 26.5979 28.4732 27.5355 27.5355C28.4732 26.5979 29 25.3261 29 24C29 22.6739 28.4732 21.4021 27.5355 20.4645C26.5979 19.5268 25.3261 19 24 19ZM24 21C24.7956 21 25.5587 21.3161 26.1213 21.8787C26.6839 22.4413 27 23.2044 27 24C27 24.7956 26.6839 25.5587 26.1213 26.1213C25.5587 26.6839 24.7956 27 24 27C23.2044 27 22.4413 26.6839 21.8787 26.1213C21.3161 25.5587 21 24.7956 21 24C21 23.2044 21.3161 22.4413 21.8787 21.8787C22.4413 21.3161 23.2044 21 24 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraUploadedIcon);
export default __webpack_public_path__ + "static/media/camera-uploaded-icon.88322f646e71429dcdbd0a0baa859200.svg";
export { ForwardRef as ReactComponent };